import React, { PureComponent } from 'react'
import './calendaritemstep.scss'
class CalendarItemStep extends PureComponent {

  render () {
    const {step} = this.props
    const style = {
      left: `${step.FromPercent}%`,
      right: `${100 - step.ToPercent}%`
    }
    let classNames = 'calendar-item-step'
    return (
      <div className={classNames} style={style} >
        {this.props.children}
      </div>
    )
  }
}

CalendarItemStep.defaultProps = {
  step: {
    FromPercent: 0,
    ToPercent: 5,
    Type: 1
  }
}

export default CalendarItemStep



// WEBPACK FOOTER //
// ./src/app/shared/components/Calendar/calendarItemStep/index.js